import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(t, e) {
  return o(), l("svg", c, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.993 2a1 1 0 0 1 1 1v1.564C15.18 4.994 17 6.646 17 8.883a1 1 0 1 1-2 0c0-.923-.754-1.896-2.007-2.27v4.582c.916.207 1.758.51 2.434.971.972.665 1.573 1.645 1.573 2.95 0 2.237-1.82 3.89-4.007 4.319V21a1 1 0 1 1-2 0v-1.52c-2.301-.346-4.266-2.04-4.266-4.364a1 1 0 0 1 2 0c0 .985.859 2.026 2.266 2.337V12.86c-1.016-.208-1.954-.523-2.692-1.027-.973-.665-1.574-1.645-1.574-2.95 0-2.325 1.965-4.018 4.266-4.364V3a1 1 0 0 1 1-1M8.727 8.883c0-.985.859-2.026 2.266-2.337v4.264q-1.012-.25-1.564-.63c-.475-.324-.702-.71-.702-1.297m4.266 8.503v-4.129q.825.232 1.306.561c.475.325.701.71.701 1.298 0 .923-.754 1.896-2.007 2.27",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: n };
export {
  a as default,
  n as render
};
//# sourceMappingURL=ic_dollar-ek3cNA5O.js.map
